import NoDataFoundIcon from "Assets/Icons/NoDataFoundIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import Typography from "Components/CommonComponents/Typography";
import { ElmentDetail } from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentPerformanceTabs/StudentDetailsTab";
import { useState } from "react";
import { Col, Popover, PopoverBody, Row } from "reactstrap";
import styled from "styled-components";
import { capitalizeWords } from "utilFunctions/helperFunctions/utilFunctions";
import "./index.css";
const ActiveProfileTextDiv = styled<any>("span")`
  border-radius: 5px;
  padding: 4px;
  background: ${(props: any) => (props.isActive ? "#50b47f" : "#E7685A")};
  color: var(--White, #fff);
  text-align: center;
  font-size: 10.328px;
  font-style: normal;
  font-weight: 400;
  width: fit-content;
`;
const MyProfilePhoenixDetails = ({
  facultyDetail,
  screen,
  branches,
  regions,
  route,
}: any) => {
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const togglePopover = (column: string, content: string) => {
    setHoveredColumn(column);
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };

  const closePopover = () => {
    setHoveredColumn(null);
    setPopoverOpen(false);
  };
  const returnRegion = (id: number) => {
    return regions?.filter((ele: any) => ele.value == id)?.[0]?.label;
  };
  const returnBranchName = (branch: any) => {
    const branchArr = branch.map((el: any) => el.businessAreaValue) || [];
    return branches
      ?.filter((ele: any) => branchArr.includes(ele.key))
      ?.map((el: any) => el.label);
  };
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen)
          ? "MyBatchesFacultyDetailTabDiv mr-3"
          : "MyBatchesFacultyDetailTabDivMB pt-0 mt-4"
      }
    >
      {route == "myprofile" ? (
        <Row>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="12"
            xs="12"
            className="text-left pl-4 pt-3"
          >
            <Typography variant="h5" color="black">
              Phoenix ERP Profile Data
            </Typography>
          </Col>
        </Row>
      ) : null}
      {facultyDetail != null ? (
        <Row className="MyBatchesFacultyDetailTabRow mt-0">
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol"
          >
            <ElmentDetail
              label={"Faculty Name"}
              value={
                facultyDetail["facultyName"] != null &&
                capitalizeWords(facultyDetail["facultyName"])
              }
            />
          </Col>

          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"Faculty Id"}
              value={facultyDetail["facultyId"]}
            />
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            {facultyDetail["region"] &&
            Array.isArray(facultyDetail["region"]) &&
            facultyDetail["region"].length > 1 ? (
              <ElmentDetail label={"Region"} value={"Multiple"} />
            ) : (
              <ElmentDetail
                label={"Region"}
                value={
                  returnRegion(facultyDetail["region"])
                    ? returnRegion(facultyDetail["region"])
                    : facultyDetail["region"].join(", ")
                }
              />
            )}
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              className="d-flex flex-column facultyDetailsCol"
              id="branchphx"
              onClick={() =>
                togglePopover(
                  "branchphx",
                  returnBranchName(
                    facultyDetail["facultyMasterBusinessAreasResponseList"]
                  )
                )
              }
            >
              <span className="studentLabel">Business Area</span>
              <div className="d-flex gap-2">
                {returnBranchName(
                  facultyDetail["facultyMasterBusinessAreasResponseList"]
                )?.[0] &&
                returnBranchName(
                  facultyDetail["facultyMasterBusinessAreasResponseList"]
                ).length > 1 ? (
                  <>
                    <span className="studentValue">
                      {
                        returnBranchName(
                          facultyDetail[
                            "facultyMasterBusinessAreasResponseList"
                          ]
                        )?.[0]
                      }{" "}
                    </span>
                    <span className="filterSpan d-flex align-items-center">
                      +
                      {returnBranchName(
                        facultyDetail["facultyMasterBusinessAreasResponseList"]
                      )?.length - 1}
                    </span>
                  </>
                ) : (
                  <span className="studentValue">
                    {
                      returnBranchName(
                        facultyDetail["facultyMasterBusinessAreasResponseList"]
                      )?.[0]
                    }
                  </span>
                )}
              </div>
            </div>

            <Popover
              placement="bottom"
              isOpen={hoveredColumn == "branchphx" ? popoverOpen : false}
              target={"branchphx"}
              toggle={closePopover}
            >
              <PopoverBody className="FacultyTablePopover branchPopover">
                {popoverContent.map((ele: any, index: number) => (
                  <div
                    key={index}
                    className="branchListing d-flex justify-content-between mb-2"
                  >
                    {ele}
                  </div>
                ))}
              </PopoverBody>
            </Popover>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <div
              onClick={() => togglePopover("subjectphx", facultyDetail.subject)}
              onMouseLeave={closePopover}
              id={"subjectphx"}
              className="facultyDetailsCol"
            >
              <Popover
                placement="bottom"
                isOpen={hoveredColumn == "subjectphx" ? popoverOpen : false}
                target={"subjectphx"}
                toggle={closePopover}
              >
                <PopoverBody className="FacultyTablePopover">
                  {popoverContent?.map((ele: any, index: number) => (
                    <div
                      key={index}
                      className="branchListing d-flex justify-content-between mb-2"
                    >
                      {ele}
                    </div>
                  ))}
                </PopoverBody>
              </Popover>
              <span className="studentLabel">Subjects</span>
              <div className="d-flex gap-2">
                {facultyDetail.subject && facultyDetail.subject.length > 1 ? (
                  <>
                    {facultyDetail?.subject?.[0]}{" "}
                    <span className="filterSpan d-flex align-items-center">
                      +{facultyDetail?.subject?.length - 1}
                    </span>
                  </>
                ) : (
                  <>{facultyDetail?.subject?.[0]}</>
                )}
              </div>
            </div>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol d-flex flex-column mt-2"
          >
            <span className="studentLabel">Status</span>
            <ActiveProfileTextDiv isActive={facultyDetail["status"] != 1}>
              {facultyDetail["status"] != 1 ? "Active" : "Inactive"}
            </ActiveProfileTextDiv>
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"MS Team ID"}
              value={facultyDetail["msTeamFacultyId"]}
            />
          </Col>
          <Col
            xxl="4"
            xl="4"
            lg="4"
            md="4"
            sm="6"
            xs="6"
            className="batchDetailMainCol mt-2"
          >
            <ElmentDetail
              label={"Faculty Email ID"}
              value={facultyDetail["facultyEmailId"]}
            />
          </Col>
        </Row>
      ) : (
        <div className="mt-4 mb-8">
          <NoResultFoundSearch
            primaryMessage="Data not found"
            secondaryMessage={
              "Seems like there was an error loading data                  "
            }
          >
            <NoDataFoundIcon />
          </NoResultFoundSearch>
        </div>
      )}
    </div>
  );
};
export default MyProfilePhoenixDetails;
